export class Frota {
    ativo: boolean; 
    capacidadeCarga: number; 
    dataCompra: string; 
    dataOdometroHorimetro: string; 
    dataTerminoGarantia: string; 
    dataVenda: string; 
    descricao: string; 
    identificacao: string; 
    anoModelo: number; 
    chassi: string; 
    codigo: string; 
    codigoPatrimonio: string; 
    numeroPassageiros: number; 
    numeroRenavam: string; 
    placa: string; 
    terceiro: boolean; 
    modeloId: number; 
    orgaoId: number; 
    areaId: number; 
    divisaoId: number; 
    setorId: number; 
    localidadeId: number; 
    corId: number; 
    situacaoId: number; 
    anoFabricacao: number; 
    numeroSerie: string; 
    motoristaPrincipalId: number; 
    odometroHorimetroId: number; 
    possuiOdometro: boolean; 
    mesLicenciamento: number; 
    mesSeguroObrigatorio: number; 
    mesIPVA: number; 
    formaControleId: number; 
    categoriaExigidaId: number; 
    placaCidadeId: number; 
    velocidadeMaximaPermitida: number; 
    cercas: string; 
    gpsImei: string; 
    gpsModeloId: number; 
    gpsTelefone: string; 
    id: number; 
}


export class FrotaImagem {
    ativo: boolean;
    data: string;
    descricao: string;
    formato: string;
    url: string;
    bemId: number;
    id: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/shared/frota.model.ts
 **/